"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const constants_1 = require("@/common/constants");
const Milestone_vue_1 = require("@/client/components/Milestone.vue");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'Milestones',
    props: {
        milestones: {
            type: Array,
            required: true,
        },
        showScores: {
            type: Boolean,
            default: true,
        },
        preferences: {
            type: Object,
            default: () => PreferencesManager_1.PreferencesManager.INSTANCE.values(),
        },
    },
    data() {
        return {
            showMilestoneDetails: (this.milestones.filter((milestone) => milestone.playerName).length === constants_1.MAX_MILESTONES ? false : this.preferences?.show_milestone_details),
            showDescription: false,
        };
    },
    components: {
        Milestone: Milestone_vue_1.default,
    },
    methods: {
        toggleDescription() {
            this.showDescription = !this.showDescription;
        },
        toggleList() {
            this.showMilestoneDetails = !this.showMilestoneDetails;
            PreferencesManager_1.PreferencesManager.INSTANCE.set('show_milestone_details', this.showMilestoneDetails);
        },
        getAvailableMilestoneSpots() {
            const count = this.milestones.filter((milestone) => milestone.playerName).length;
            return Array(constants_1.MAX_MILESTONES - count).fill(constants_1.MILESTONE_COST);
        },
        isLearnerModeOn() {
            return this.preferences.learner_mode;
        },
    },
});
